import { PageableModel } from "./pageable-model";
import { SortModel } from "./sort-model";

export class Page<T> {
    content: T[];
    pageable: PageableModel;
    totalPages: number;
    totalElements: number;
    last: boolean;
    number: number;
    size: number;
    sort: SortModel;
    numberOfElements: number;
    first: boolean;
    empty: boolean;
}